"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractAccessToken = void 0;
exports.extractAccessToken = function (session, getAccessToken) {
    if (!session) {
        return null;
    }
    if (getAccessToken) {
        return getAccessToken(session);
    }
    if (typeof session !== 'string') {
        throw Error("Access token can not be extracted. Either whole 'session' must be a string (access token only) or 'getAccessToken' function should be provided");
    }
    return session;
};
